var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-snackbar',{attrs:{"top":"","text":"","color":_vm.color},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"id":"close-button","text":"","color":_vm.color},on:{"click":function($event){_vm.show = false}}},[_vm._v("Close")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }